import { render } from "./App.vue?vue&type=template&id=21b62638&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=21b62638&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-mabilisloan-yph1-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b62638"]])

export default __exports__